export class WorkOrderFilters {
    [key: string]: boolean;
    includeAll: boolean = true;
    includeRtm: boolean;
}
